import { render, staticRenderFns } from "./rateIcon.vue?vue&type=template&id=5aa760c0&scoped=true"
import script from "./rateIcon.vue?vue&type=script&lang=js"
export * from "./rateIcon.vue?vue&type=script&lang=js"
import style0 from "./rateIcon.vue?vue&type=style&index=0&id=5aa760c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa760c0",
  null
  
)

export default component.exports